import {Drawer, styled, Typography} from "@mui/material";
import {FlexColumn, ImgBox } from "../../../styles/layout/boxes";
import {TButtonProps} from "./content/buttons/SideBarButtons.styles";

export const SidebarContainer = styled(Drawer)`
  .MuiDrawer-paper {
    transition: 0.3s;
    background-image: linear-gradient(4deg, #3EB1FF 2%, #5959F2 100%);
    width: 20rem;
    min-height: 100vh;
    height: 100%;
    border-right: none;
  }
`;

export const SideBarFlexColumn = styled(FlexColumn)`
  height: 100%;
  width: 100%;
`

export const LogoBox = styled(ImgBox)`
  width: 100%;
  max-width: 11rem;
  cursor: pointer;
`

export const SideBarText = styled(
    Typography, {
        shouldForwardProp: (propName) => (!['active'].includes(propName.toString()))
    })<TButtonProps>(({theme, active}) => ({
    textDecoration: 'none',
    color: active ? theme.palette.primary.main : '#ffffff',
    margin: '1.2rem 0',
    textAlign: 'center',
    '& a': {
        textDecoration: 'none',
        color: '#ffffff',
        cursor: 'pointer',
    }
}))

SideBarText.defaultProps = {
    variant: 'body2',
}

